export default {
    name: "b4-login-modal",
    data: function () {
        return {
            dialog: false
        };
    }
};
